import type { RouteDef } from '@ztechapps/common.contract'
import { Container, WebuiIocKey } from '@ztechapps/webui.contract'
import { RequesterTemplateVariablesProvider } from '@ztechapps/chat.webui'
import { NullComponent } from '@ztechapps/webui.util'
import { TeacherSelect } from '../components/conversation/TeacherSelect'
import { TeacherWidget } from '../components/conversation/TeacherWidget'
import { routesDef } from './routes'

export function setupContainer() {
  const container = new Container()

  // QuickScore Admin is a lean shell — no product/order/customer module containers to bind.
  // The shared conversation UI resolves its host pieces through these keys.
  container.bind<RouteDef>(WebuiIocKey.routes.conversationItem).to(routesDef.ConversationItemPage)

  // The requester and the new-conversation recipient are teachers.
  container.bind(WebuiIocKey.customer.customerWidget).to(TeacherWidget)
  container.bind(WebuiIocKey.customer.customerSelectCreatable).to(TeacherSelect)
  container.bind(WebuiIocKey.customer.contactSelect).to(TeacherSelect)

  // QuickScore has no orders to create from a conversation: this slot renders nothing. The order picker and the
  // customer info form are bound nowhere — `conversationHostConfig` tells the conversation UI not to look for them.
  container.bind(WebuiIocKey.order.createOrderFromConversationButton).to(NullComponent)

  container.bind(WebuiIocKey.chat.conversationTemplateVariablesProvider).to(RequesterTemplateVariablesProvider)

  return container
}
